import React from "react";
import logo from "../Assets/Artboard 4@300x.png";
import { Link, NavLink } from "react-router-dom";

function Navbar() {
  const navLinkStyle = ({ isActive }) => ({
    color: isActive ? "#1DA9E8" : "#ffffff",
    fontWeight: 600,
    marginLeft: "18px",
    textDecoration: "none",
    fontSize: "15px",
  });

return (
  <nav
    className="navbar navbar-expand-lg"
    style={{
      backgroundColor: "#0B5CAD",
      padding: "14px 0",
      boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
    }}
  >
    <div className="container custom-navbar">
      {/* Logo */}
      <Link
        to="/"
        className="navbar-brand d-flex align-items-center"
        style={{
          color: "#ffffff",
          fontWeight: 700,
          fontSize: "28px",
          letterSpacing: "1px",
          textDecoration: "none",
          gap: "10px",
        }}
      >
        <img
          src={logo}
          alt="Electromates Logo"
          style={{
            height: "42px",
            width: "42px",
            objectFit: "contain",
          }}
        />
        <span>ELECTROMATES</span>
      </Link>

      {/* Hamburger */}
      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarContent"
        aria-controls="navbarContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
        style={{
          border: "1px solid #ffffff",
          backgroundColor: "#ffffff",
        }}
      >
        <span
          className="navbar-toggler-icon"
          style={{ filter: "invert(1)" }}
        ></span>
      </button>

      {/* Menu */}
      <div className="collapse navbar-collapse" id="navbarContent">
        <div className="navbar-nav ms-auto text-center">
          <NavLink to="/" style={navLinkStyle}>
            Home
          </NavLink>
          <NavLink to="/about" style={navLinkStyle}>
            About
          </NavLink>
          <NavLink to="/capabilities" style={navLinkStyle}>
            Capabilities
          </NavLink>
          <NavLink to="/solutions" style={navLinkStyle}>
            Solutions
          </NavLink>
          <NavLink to="/services" style={navLinkStyle}>
            Services
          </NavLink>
          <NavLink to="/clients" style={navLinkStyle}>
            Clients
          </NavLink>
          <NavLink to="/contact" style={navLinkStyle}>
            Contact Us
          </NavLink>
        </div>
      </div>
    </div>

    {/* ✅ MOBILE ONLY FIX */}
    <style>{`
      @media (max-width: 991px) {
        .custom-navbar {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: nowrap;
          position: relative;
        }

        #navbarContent {
          position: absolute;
          top: 100%;
          left: 0;
          width: 100%;
          background-color: #0B5CAD;
          z-index: 1000;
        }
      }
    `}</style>
  </nav>
);
}

export default Navbar;